var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-right" },
    [
      _c("small", { staticClass: "text-muted" }, [_vm._v("Desenvolvido por:")]),
      _vm._v(" "),
      _c(
        "b-link",
        { attrs: { href: "https://securamdata.com", target: "_brank" } },
        [_vm._v("securamdata.com")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }